import React from 'react';
import { TopBar } from './components/TopBar';
import { LocationRibbon } from './components/LocationRibbon';
import { Hero } from './components/Hero';
import { BookingForm } from './components/BookingForm';
import { AffirmRibbon } from './components/AffirmRibbon';
import { TreatmentGallery } from './components/TreatmentGallery';
import { TrustStrip } from './components/TrustStrip';
import { InstagramRibbon } from './components/InstagramRibbon';
import { LegalFooter } from './components/LegalFooter';
export function App() {
  return <div className="min-h-screen bg-be-navy font-sans selection:bg-be-pink selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <LocationRibbon data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <BookingForm data-id="element-5" />
        <AffirmRibbon data-id="element-6" />
        <TreatmentGallery data-id="element-7" />
        <TrustStrip data-id="element-8" />
      </main>
      <InstagramRibbon data-id="element-9" />
      <LegalFooter data-id="element-10" />
    </div>;
}